/* Javascript for Sticky checkout bar v1 - V */

document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.match(/^\/cart/)) return;

  const stickyStrip = document.getElementById('sticky-checkout-strip');
  const stickyTotal = document.getElementById('sticky-checkout-total');
  const stickyItems = document.getElementById('sticky-checkout-items');
  const subtotalEl = document.querySelector('.cart-subtotal [data-cart-total]');
  const cartContainer = document.querySelector('[data-html="list"]');

  if (!stickyTotal || !subtotalEl) return;

  // --- Helper functions ---
  function updateFromCartJSON() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        stickyTotal.textContent = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: window.Shopify.currency.active || 'USD',
        }).format(cart.total_price / 100);


        stickyItems.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;


        stickyStrip.style.display = cart.item_count === 0 ? 'none' : '';
        stickyStrip.setAttribute('aria-hidden', cart.item_count === 0 ? 'true' : 'false');
      })
      .catch((err) => console.warn('[StickyCheckout] cart.js fetch failed', err));
  }

  // --- Observe subtotal text changes ---
  const observer = new MutationObserver(() => updateFromCartJSON());
  observer.observe(subtotalEl, { childList: true, subtree: true, characterData: true });

  // --- Observe for re-render of cart section (AJAX reload) ---
  if (cartContainer) {
    const containerObserver = new MutationObserver(() => updateFromCartJSON());
    containerObserver.observe(cartContainer, { childList: true, subtree: true });
  }

  // --- Trigger update on quantity control clicks ---
  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity__button')) {
      setTimeout(updateFromCartJSON, 400);
    }
  });

  // --- Trigger update on quantity field changes ---
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name^="updates"]')) {
      setTimeout(updateFromCartJSON, 400);
    }
  });

  

  // --- Initial state ---
  updateFromCartJSON();
});